import { Link, NavLink } from "react-router-dom";
import { Film } from "lucide-react";

const linkBase = "font-mono-ui text-xs uppercase tracking-[0.2em] transition-colors duration-200";

export default function Navbar() {
  return (
    <header
      data-testid="app-navbar"
      className="sticky top-0 z-50 border-b border-white/10 bg-[#050505]/85 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-5 md:px-10">
        <Link
          to="/"
          data-testid="nav-logo"
          className="group flex items-center gap-3"
        >
          <div className="flex h-8 w-8 items-center justify-center border border-white/15 group-hover:border-[#E50914]">
            <Film className="h-4 w-4 text-white group-hover:text-[#E50914]" strokeWidth={1.5} />
          </div>
          <div className="flex flex-col leading-none">
            <span className="font-display text-lg font-bold tracking-tight">
              REELFORGE <span className="text-[#E50914]">STUDIO</span>
            </span>
            <span className="mt-1 font-mono-ui text-[8px] uppercase tracking-[0.32em] text-white/40">
              A Free Determinism Production
            </span>
          </div>
        </Link>
        <nav className="flex items-center gap-8">
          <NavLink
            to="/"
            end
            data-testid="nav-studio"
            className={({ isActive }) =>
              `${linkBase} ${isActive ? "text-white" : "text-white/50 hover:text-white"}`
            }
          >
            Studio
          </NavLink>
          <NavLink
            to="/gallery"
            data-testid="nav-gallery"
            className={({ isActive }) =>
              `${linkBase} ${isActive ? "text-white" : "text-white/50 hover:text-white"}`
            }
          >
            Reels
          </NavLink>
          <a
            href="/"
            data-testid="nav-powered"
            className={`${linkBase} hidden text-white/40 hover:text-white md:inline`}
          >
            <span className="mr-1 inline-block h-1.5 w-1.5 rounded-full bg-[#E50914] align-middle rec-dot" />
            100% Free · No API keys
          </a>
        </nav>
      </div>
    </header>
  );
}
